export default function Plane(props) {
  const size = Array.isArray(props?.size) && props.size.length === 2 ? props.size : [300, 300];
  const position = Array.isArray(props?.position) && props.position.length === 3 ? props.position : [0, -1, 0];
  const rotation = Array.isArray(props?.rotation) && props.rotation.length === 3 ? props.rotation : [-Math.PI / 2, 0, 0];
  const color = props?.color || '#5e5c5c';
  const metalness = props?.metalness ?? 0.4;
  const roughness = props?.roughness ?? 0.8;
  const emissive = props?.emissive ?? '#111111';
  const emissiveIntensity = props?.emissiveIntensity ?? 0.7;

  return (
    <mesh position={position} rotation={rotation}>
      <planeGeometry attach="geometry" args={size} />
      <meshStandardMaterial attach="material" color={color} metalness={metalness} roughness={roughness} emissive={emissive} emissiveIntensity={emissiveIntensity} />
    </mesh>
  );
}
